module.exports = __webpack_public_path__ + "static/media/banner_slider1.4b2e5890.jpg";